import cQuantity from '#themes/default/default/components/quantity/quantity.js';
import cSelect from '#themes/default/default/components/select/select.js';
import cSkeleton from '#themes/default/default/components/skeleton/skeleton.js';
import cSvg from '#themes/default/default/components/svg/svg.js';
import cTooltip from '#themes/default/default/components/tooltip/tooltip.js';

import template from './product.html' with { type: 'html' };

export default {
	name: 'CProduct',
	components: {
		cQuantity,
		cSelect,
		cSkeleton,
		cSvg,
		cTooltip
	},
	props: {
		isCompanyDetailsPage: {
			type: Boolean,
			default: false
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		isShoppingCartPage: {
			type: Boolean,
			default: false
		},
		isThankYouPage: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		product: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		},
		utils: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			activationStatuses: {
				success: {
					text: 'thankYou_activationSuccess',
					value: 100
				},
				failure: {
					text: 'thankYou_activationFailure',
					value: 100
				},
				progress: {
					text: 'thankYou_activationProgress',
					value: 0
				}
			},
			hasProductEditNote: false
		};
	},
	computed: {
		areSelectorsDisabled() {
			return this.isCompanyDetailsPage || this.isLoading;
		},
		isEmpty() {
			return this.$store.state.isEmpty;
		},
		hasFulfillment() {
			return this.product.fulfillment && this.product.fulfillment.license;
		},
		activationStatus() {
			let activationStatus;
			if (this.product.fulfillment.activation) {
				activationStatus = {
					'Activation: Success': 'success',
					'Activation: Fail': 'failure'
				}[this.product.fulfillment.activation.status];
			}
			return activationStatus || 'progress';
		},
		getFulfillment() {
			if (this.hasFulfillment) {
				const license = this.product.fulfillment.license;
				const fulfillmentInfo = license.map((item) => {
					return {
						type: item.contentType,
						value: item.content
					};
				});
				const fulfillmentJson = JSON.stringify(fulfillmentInfo);
				return fulfillmentJson;
			} else {
				return null;
			}
		},
		productNote() {
			return this.selectedPayment.isManualRenewal || this.product.isManualRenewal ? this.product.manualRenewalNote : this.product.automaticRenewalNote;
		},
		productVariations() {
			if (Array.isArray(this.product.variations) && this.product.variations.length) {
				return this.product.variations.map((item) => ({
					value: item.id,
					label: item.monthsValidity >= 12 ? this.t('cart_variantSelectorYear', {
						validity: item.yearsValidity
					}) : this.t('cart_variantSelectorMonth', {
						validity: item.monthsValidity
					}),
					selected: item.selected
				}));
			} else {
				return null;
			}
		},
		showFuturePrice() {
			const hasDifferentFuturePrice = this.product.futurePrice && this.product.price.street.unformatted !== this.product.futurePrice?.street.unformatted && this.product.futurePrice?.street.unformatted !== this.product.conversionPrice?.street.unformatted;
			const hasAutoRenewal = this.selectedPayment && this.order && !(this.selectedPayment.isManualRenewal || this.order.hasManualRenewalProduct);
			const hasBusinessProduct = this.order.hasBusinessProduct;
			return this.theme.variables.hasFuturePrice && hasDifferentFuturePrice && hasAutoRenewal && !hasBusinessProduct;
		},
		showDisclaimer() {
			return this.$store.getters.showDisclaimer;
		},
		isDirectUpsell() {
			// Case when a customer has an active license and upselling - arrived to cart directly (not offer modal); eg. PR-ASWUPSELL-SLA-MULTI-10
			return this.order.campaign.includes('ASWUPSELL');
		}
	},
	watch: {
		$route() {
			this.hasProductEditNote = false;
		}
	},
	methods: {
		async changeVariation(newProduct) {
			this.$emit('removeProduct', {
				productId: this.product.id
			});
			await this.$store.dispatch('changeVariation', {
				oldProduct: this.product.id,
				newProduct
			});
			this.$emit('addProduct', {
				productId: newProduct
			});
			await this.$nextTick();
			await this.updateUrlQuery();
		},
		async removeProduct() {
			this.$emit('removeProduct', {
				productId: this.product.id
			});
			await this.$store.dispatch('removeProduct', {
				product: this.product.id
			});
			await this.$nextTick();
			await this.updateUrlQuery();
		}
	},
	template
};
